<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-play`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_aaff17d8db__clip0_6086_485462)"><path d="M7.99951 0.5C12.1409 0.5 15.4993 3.8576 15.4995 7.99902C15.4995 12.1407 12.141 15.498 7.99951 15.498C3.8582 15.4978 0.500488 12.1405 0.500488 7.99902C0.500742 3.85776 3.85836 0.500257 7.99951 0.5ZM7.99951 1.83008C4.59278 1.83033 1.83082 4.59241 1.83057 7.99902C1.83057 11.4059 4.59263 14.1677 7.99951 14.168C11.4066 14.168 14.1694 11.406 14.1694 7.99902C14.1692 4.59225 11.4065 1.83008 7.99951 1.83008ZM6.67725 5.52734C6.83881 5.51036 7.03638 5.62325 7.43018 5.85059L9.95068 7.30664C10.3444 7.53396 10.5418 7.64752 10.6079 7.7959C10.6655 7.92535 10.6655 8.07367 10.6079 8.20312C10.5417 8.35139 10.3442 8.46519 9.95068 8.69238L7.43018 10.1475C7.03639 10.3748 6.83881 10.4887 6.67725 10.4717C6.53658 10.4568 6.4089 10.3829 6.32568 10.2686C6.23021 10.1371 6.22998 9.90965 6.22998 9.45508V6.54395C6.22998 6.08924 6.23019 5.8619 6.32568 5.73047C6.40889 5.61598 6.53652 5.54226 6.67725 5.52734Z"/></g><defs><clipPath id="svg_aaff17d8db__clip0_6086_485462"><path d="M0 0H16V16H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconLinePlay',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
